import { render } from "./QuantyBarChart.vue?vue&type=template&id=04a657ea&scoped=true"
import script from "./QuantyBarChart.vue?vue&type=script&lang=js"
export * from "./QuantyBarChart.vue?vue&type=script&lang=js"

import "./QuantyBarChart.vue?vue&type=style&index=0&id=04a657ea&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a657ea"]])

export default __exports__